import reuqest from '@/utitl/request'
let serve = process.env.NODE_ENV == "development" ? '' : '/project_manage'
//公司
export const intention = (data) => {
    return reuqest({
        url: `${serve}/add/customer/intention`,
        method: 'post',
        data,
    })
}